import { gql } from "@apollo/client/core";

export const getCustomerQuery = gql`
    query GetCustomer($emailAddress: String!) {
        customer(emailAddress: $emailAddress) {
            id
            emailAddress
            hasBundleTemplates
            partner {
                id
            }
            productCollectionCustomers {
                id
                productCollection {
                    id
                }
            }
        }
    }
`;

export const customerCreateMutation = gql`
    mutation CustomerCreate($details: CustomerDetailsInput!) {
        customerCreate(details: $details) {
            id
            emailAddress
            partner {
                id
            }
        }
    }
`;

export const customerAuthenticateMutation = gql`
    mutation CustomerAuthenticate($loginToken: String!) {
        customerAuthenticate(loginToken: $loginToken) {
            id
            emailAddress
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
            partner {
                id
            }
        }
    }
`;

export const customerGenerateVerificationCodeMutation = gql`
    mutation CustomerGenerateVerificationCode($emailAddress: String!) {
        customerGenerateVerificationCode(emailAddress: $emailAddress)
    }
`;

export const customerVerifyCodeMutation = gql`
    mutation CustomerVerifyCode($emailAddress: String!, $verificationCode: String!) {
        customerVerifyCode(emailAddress: $emailAddress, verificationCode: $verificationCode) {
            id
            emailAddress
            loginToken
            partner {
                id
            }
            stakeholders {
                id
                type
                transaction {
                    id
                }
            }
            bundleStakeholders {
                id
                authorizationStatus
                authorizationDate
                authorizationNote
                type
                bundle {
                    id
                    transactions {
                        id
                    }
                }
            }
        }
    }
`;

export const customerMetafieldsQuery = gql`
    query CustomerMetafields($id: String!) {
        metafields(entityId: $id) {
            id
            createdAt
            updatedAt
            entityId
            value
            metafieldConfiguration {
                id
                createdAt
                updatedAt
                entityType
                metafieldType
                name
            }
        }
    }
`;
